module.exports = __webpack_public_path__ + "img/party.8fabd22b.jpg";